var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('p',[_vm._v(_vm._s(_vm.question.question))]),_c('answer-type-component',{attrs:{"item":_vm.question,"question":_vm.question,"answerType":_vm.question.answerType}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }